export default __webpack_public_path__ + "static/media/xero_icon.c0698293.png";